export const featureId = 'documentCenter';